/**
 * Конфигурация брендинга приложения
 * Централизованное место для всех брендинговых констант
 */

export const BRANDING_CONFIG = {
  // Название приложения
  APP_NAME: 'WMT Релевантер',
  
  // Описание приложения
  APP_DESCRIPTION: 'HR Recruiter System',
  
  // Версия приложения
  APP_VERSION: '1.0.0',
  
  // Контактная информация
  SUPPORT_EMAIL: 'support@hrrecruiter.com',
  
  // URL документации
  DOCS_URL: 'https://docs.hrrecruiter.com',

  // Дефолтные цвета брендинга
  DEFAULT_PRIMARY_COLOR: '#e16349',
  // Hover вычисляется автоматически затемнением на 12%

  // Дефолтные цвета для AI-кнопок (secondary)
  DEFAULT_AI_COLOR: '#df1c41',

  // Логотип главной компании (для неавторизованных экранов)
  // Можно задать через ENV: REACT_APP_MAIN_COMPANY_LOGO_URL
  MAIN_COMPANY_LOGO_URL: (process.env.REACT_APP_MAIN_COMPANY_LOGO_URL || '').toString()
} as const;

// Экспорт по умолчанию для обратной совместимости
export default BRANDING_CONFIG;
